export type Permission =
  | 'view-dashboard'
  | 'view-programplan'
  | 'view-statistics'
  | 'view-archive'
  // Aktions-Berechtigungen (Element-Ebene):
  | 'control-voxtral'    // Voxtral Start/Stop/Reset/Terminate + Abort-Rollover
  | 'manage-broadcasts'  // Planung, FAB, Korrektur, Reset All, Upload, Zeiten/Redsys, NOT-AUS
  | 'delete-archive'     // Archiv-Einträge löschen
  // 2026-09-07 — Dashboard: primäre Live-Engine pro Sender + Umgebungssteuerung
  // (Aktivieren/Ruhezustand/Deaktivieren). Backend-seitig KiutAdmin.
  | 'control-infrastructure';

export type Role = 'Admin' | 'Redakteur' | 'Editor';

export const ROLE_PERMISSIONS: Record<Role, Permission[]> = {
  Admin: [
    'view-dashboard', 'view-archive', 'view-programplan', 'view-statistics',
    'control-voxtral', 'manage-broadcasts', 'delete-archive',
    'control-infrastructure',
  ],
  Redakteur: ['view-archive', 'view-programplan', 'manage-broadcasts', 'delete-archive'],
  // view-programplan: Editor muss Details-Panel & Plan-Dialog sehen können
  // (Bedienelemente dort sind für Editor sichtbar, aber deaktiviert).
  Editor: ['view-archive', 'view-programplan'],
};
